import { render } from "./CampaignCreateView.vue?vue&type=template&id=2a88949e"
import script from "./CampaignCreateView.vue?vue&type=script&lang=js"
export * from "./CampaignCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__